import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Container, Button } from '@mui/material';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import HomeIcon from '@mui/icons-material/Home';     // Icon for home button
import { dataApi } from '../services/dataApi';
import ResearchPage from './ResearchPage';



function SharedResearchViewer() {
  const { shareID } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSharedData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await dataApi.getSharedResearch(shareID);
        setInitialData(data); 

      } catch (err) {
        console.error("Shared Research Load Error:", err);
        // We use a generic message for the UI, but log the real error
        setError("Link invalid or expired"); 
      } finally {
        setLoading(false);
      }
    };

    if (shareID) {
      loadSharedData();
    }
  }, [shareID]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 15 }}>
        <CircularProgress sx={{ color: 'var(--tertiary-color)' }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="sm">
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            textAlign: 'center',
            mt: 15,
            gap: 2
          }}
        >
          {/* 1. Large Neutral Icon */}
          <CloudOffIcon sx={{ fontSize: 100, color: '#e0e0e0' }} />
          
          {/* 2. Friendly Headline */}
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'text.primary' }}>
            Research Not Found
        </Typography>
          
          {/* 3. Helpful Subtext */}
          <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 400, mb: 2 }}>
            The link you followed may be broken, expired, or the research has been removed by its owner.
        </Typography>

          {/* 4. Call to Action Button */}
          <Button 
            variant="contained" 
            size="large"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ 
              textTransform: 'none',
              fontWeight: 600,
              padding: '10px 30px',
              borderRadius: '8px',
              backgroundColor: 'var(--tertiary-color)', // Using your brand variable
              '&:hover': {
                backgroundColor: 'var(--secondary-color)',
                opacity: 0.9
              }
            }}
          >
            Go to Home
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <ResearchPage 
      readOnly={true} 
      initialData={initialData} 
    />
  );
}

export default SharedResearchViewer;